/* FG: Bereinigt die Fahrzeug-Finder-Daten (doppelte Modellnamen, ueberlappende Baujahr-Bereiche). */
(function () {
  if (window.FGNorm) return;
  var YMAX = new Date().getFullYear();
  function undouble(s) {
    var w = s.split(' ');
    if (w.length > 1 && w.length % 2 === 0) {
      var h = w.length / 2;
      if (w.slice(0, h).join(' ').toLowerCase() === w.slice(h).join(' ').toLowerCase()) return w.slice(0, h).join(' ');
    }
    return s;
  }
  function cleanModel(n) {
    var s = String(n == null ? '' : n).replace(/\s+/g, ' ').trim();
    s = undouble(s);
    s = s.replace(/^\d+\s*-\s*\d+\s*ccm\s+/i, '').replace(/^\d+\s*(?:cc|ccm)\s+/i, '');
    s = s.replace(/\s+\d{4}\s*-?\s*and up$/i, '').replace(/,\s*(?=\()/g, ' ').replace(/\s+/g, ' ').trim();
    return undouble(s) || String(n);
  }
  function yearsOf(k) {
    k = String(k == null ? '' : k).trim();
    var m, o = [], y;
    if (k === '-' || k === '') return ['-'];
    if ((m = /^(\d{4})$/.exec(k))) return [m[1]];
    if ((m = /^(\d{4})\s*[-–]\s*(\d{4})$/.exec(k))) { for (y = +m[1]; y <= +m[2]; y++) o.push(String(y)); return o; }
    if ((m = /^(\d{4})\s*>$/.exec(k))) { for (y = +m[1]; y <= YMAX; y++) o.push(String(y)); return o; }
    return null;
  }
  function sortYears(keys) {
    return keys.slice().sort(function (a, b) {
      if (a === '-') return 1;
      if (b === '-') return -1;
      return parseInt(b, 10) - parseInt(a, 10);
    });
  }
  function parseChunks(parts) {
    try { return JSON.parse(parts.join('')); } catch (e) {}
    /* Reparatur: ein ueberzaehliges Anfangszeichen an einer Chunk-Grenze entfernen */
    for (var i = 1; i < parts.length; i++) {
      var p = parts.slice();
      p[i] = p[i].slice(1);
      try { return JSON.parse(p.join('')); } catch (e2) {}
    }
    throw new Error('chunks');
  }
  function norm(d) {
    if (d && d.__fgn) return d.__fgn;
    var out = { vehicles: {}, products: d.products || {} };
    Object.keys(d.vehicles || {}).forEach(function (hub) {
      var tgt = out.vehicles[hub] = out.vehicles[hub] || {};
      Object.keys(d.vehicles[hub]).forEach(function (model) {
        var cm = cleanModel(model);
        var bucket = tgt[cm] = tgt[cm] || {};
        var src = d.vehicles[hub][model];
        Object.keys(src).forEach(function (key) {
          var ys = yearsOf(key) || [String(key)];
          ys.forEach(function (y) {
            var arr = bucket[y] = bucket[y] || [];
            (src[key] || []).forEach(function (s) { if (arr.indexOf(s) === -1) arr.push(s); });
          });
        });
      });
    });
    try { Object.defineProperty(d, '__fgn', { value: out, enumerable: false }); } catch (e) {}
    return out;
  }
  function resolveYear(bucket, bj) {
    if (!bucket) return null;
    if (bucket[bj]) return bj;
    var ys = yearsOf(bj);
    if (ys) { for (var i = ys.length - 1; i >= 0; i--) if (bucket[ys[i]]) return ys[i]; }
    return null;
  }
  function skusFor(d, hub, model, bj) {
    var n = norm(d), m = n.vehicles[hub] && n.vehicles[hub][cleanModel(model)];
    if (m && m[bj]) return m[bj];
    var rm = d.vehicles && d.vehicles[hub] && d.vehicles[hub][model];
    if (rm && rm[bj]) return rm[bj];
    var ys = yearsOf(bj);
    if (m && ys && bj !== '-') {
      var seen = {}, out = [];
      ys.forEach(function (y) { (m[y] || []).forEach(function (s) { if (!seen[s]) { seen[s] = 1; out.push(s); } }); });
      return out;
    }
    return [];
  }
  window.FGNorm = { cleanModel: cleanModel, yearsOf: yearsOf, sortYears: sortYears, norm: norm, parseChunks: parseChunks, resolveYear: resolveYear, skusFor: skusFor };
})();

/* ---- Passt-Pruefung (Produktseite + Warenkorb): Baujahr bereichsfaehig ---- */
(function () {
  if (window.__fgFitFix) return;
  window.__fgFitFix = true;
  var KEY = 'fzf_current_vehicle_v1';
  function esc(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function wordMatch(line, token) {
    if (!token) return true;
    try { return new RegExp('\\b' + esc(token) + '\\b', 'i').test(line); } catch (e) { return line.toLowerCase().indexOf(String(token).toLowerCase()) !== -1; }
  }
  function yearMatch(line, yv) {
    yv = String(yv == null ? '' : yv).trim();
    if (!yv || yv === '-') return true;
    if (!/^\d{4}$/.test(yv)) return wordMatch(line, yv);
    var n = +yv, hit = false, t = String(line);
    t = t.replace(/(^|[^\d])((?:19|20)\d{2})\s*(?:-|–|—|bis|to)\s*((?:19|20)\d{2}|\d{2})(?!\d)/gi, function (m, p, a, b) {
      a = +a; b = String(b).length === 2 ? Math.floor(a / 100) * 100 + (+b) : +b;
      if (n >= a && n <= b) hit = true; return p + ' ';
    });
    t = t.replace(/(^|[^\d])ab\s+(?:baujahr\s+)?((?:19|20)\d{2})/gi, function (m, p, a) { if (n >= +a) hit = true; return p + ' '; });
    t = t.replace(/(^|[^\d])((?:19|20)\d{2})\s*(?:>|\+|-(?!\s*\d)|&gt;)/gi, function (m, p, a) { if (n >= +a) hit = true; return p + ' '; });
    t.replace(/(^|[^\d])((?:19|20)\d{2})(?!\d)/g, function (m, p, a) { if (+a === n) hit = true; return p + ' '; });
    return hit;
  }
  function cleanM(m) { return window.FGNorm ? window.FGNorm.cleanModel(m) : String(m); }
  function getVehicle(allowUrl) {
    if (allowUrl) {
      try {
        var p = new URLSearchParams(location.search), h = p.get('fzf_h'), m = p.get('fzf_m'), hub = p.get('fzf_hub'), bj = p.get('fzf_bj');
        if (h && m && hub && bj) return { hersteller: h, modell: m, hubraum: hub, baujahr: bj };
      } catch (e) {}
    }
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (v && v.hersteller && v.modell && v.hubraum && v.baujahr) return v;
    } catch (e2) {}
    return null;
  }
  function label(v) {
    return v.hersteller + ' ' + cleanM(v.modell) + ' ' + v.hubraum + (v.hubraum === 'Sonstige' ? '' : 'ccm') + (v.baujahr && v.baujahr !== '-' ? ' (' + v.baujahr + ')' : '');
  }
  function lines(raw) { return String(raw || '').split(/\r?\n|<br\s*\/?>/i).map(function (l) { return l.trim(); }).filter(Boolean); }
  function isMatch(v, raw) {
    var model = cleanM(v.modell).toLowerCase();
    return lines(raw).some(function (line) {
      var l = line.toLowerCase();
      return l.indexOf(String(v.hersteller).toLowerCase()) !== -1 && l.indexOf(model) !== -1 &&
        (v.hubraum === 'Sonstige' ? true : wordMatch(line, v.hubraum)) && yearMatch(line, v.baujahr);
    });
  }
  function herstellerOk(v, raw) { return String(raw || '').toLowerCase().indexOf(String(v.hersteller).toLowerCase()) !== -1; }

  /* Produktseite */
  function fixProduct() {
    var root = document.querySelector('[id^="FgVehicleFit-"]'), dataEl = document.querySelector('[id^="FgVfitData-"]');
    if (!root || !dataEl) return;
    var v = getVehicle(true); if (!v) return;
    var raw = ''; try { raw = JSON.parse(dataEl.textContent) || ''; } catch (e) {}
    if (!lines(raw).length) return;
    var match = document.querySelector('[id^="FgVfitMatch-"]'), unsure = document.querySelector('[id^="FgVfitUnsure-"]'), cta = document.querySelector('[id^="FgVfitCta-"]');
    var ml = document.querySelector('[id^="FgVfitVehicleLabel-"]'), ul = document.querySelector('[id^="FgVfitUnsureLabel-"]');
    var ok = isMatch(v, raw);
    if (cta) cta.hidden = true;
    if (match) match.hidden = !ok;
    if (unsure) unsure.hidden = ok;
    if (ml) ml.textContent = label(v);
    if (ul) ul.textContent = label(v);
    root.hidden = false;
  }

  /* Warenkorb */
  function fixCart() {
    var dataEl = document.getElementById('FgCartFitData'); if (!dataEl) return;
    var v = getVehicle(false); if (!v) return;
    var data = {}; try { data = JSON.parse(dataEl.textContent) || {}; } catch (e) {}
    var items = document.querySelectorAll('.cart-item');
    for (var i = 0; i < items.length; i++) {
      var box = items[i].querySelector('.fg-cart-fit'), link = items[i].querySelector('.cart-item__name');
      if (!box || !link) continue;
      var href = link.getAttribute('href') || '', k = href.indexOf('/products/'); if (k === -1) continue;
      var raw = data[href.slice(k + 10).split('?')[0].split('#')[0]]; if (!raw) continue;
      var state = isMatch(v, raw) ? 'ok' : (herstellerOk(v, raw) ? 'unsure' : 'no');
      if (box.getAttribute('data-fgfix') === state + '|' + label(v)) continue;
      box.className = 'fg-cart-fit fg-cart-fit--' + state;
      box.textContent = '';
      var st = document.createElement('strong'); st.textContent = label(v);
      if (state === 'ok') { box.appendChild(document.createTextNode('✓ Passt zu deinem ')); box.appendChild(st); }
      else if (state === 'no') { box.appendChild(document.createTextNode('Nicht für dein ')); box.appendChild(st); box.appendChild(document.createTextNode(' vorgesehen.')); }
      else { box.appendChild(document.createTextNode('Bitte Kompatibilität für dein ')); box.appendChild(st); box.appendChild(document.createTextNode(' prüfen.')); }
      box.setAttribute('data-fgfix', state + '|' + label(v));
    }
  }
  function start() {
    try { fixProduct(); } catch (e) {}
    if (document.getElementById('FgCartFitData')) {
      var t;
      var run = function () { clearTimeout(t); t = setTimeout(function () { try { fixCart(); } catch (e) {} }, 120); };
      run();
      new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
    }
  }
  window.FGNorm = window.FGNorm || {};
  window.FGNorm.yearMatch = yearMatch;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* FG: Lagerbestand-Hinweis aus (fast alle Artikel stehen auf Bestand 1) + Preise einheitlich + Startseiten-Raster gleich breit/hoch (mobil) + Produktkarten einheitlich quadratisch (Bild ganz sichtbar) + Finder-Ergebniskarten mobil untereinander + Platzhalter ohne Bild */
(function () {
  if (document.getElementById('fg-fzf-cards-css')) return;
  var st = document.createElement('style');
  st.id = 'fg-fzf-cards-css';
  st.textContent = ".product__inventory,p[id^=\"Inventory-\"]{display:none !important}.product-card-wrapper .price,.fg-na-price,.fg-bs-price{letter-spacing:0 !important}.product-card-wrapper .price .price-item--last,.product-card-wrapper .price__regular .price-item--regular,.fg-na-price,.fg-bs-price{font-family:inherit;font-size:16px !important;font-weight:700 !important;line-height:1.3 !important;letter-spacing:0 !important;color:#c22631 !important}.product-card-wrapper .price__sale s.price-item--regular{font-size:13px !important;font-weight:400 !important;letter-spacing:0 !important;color:rgba(10,10,10,.5) !important}.fg-cat-grid,.fg-na-grid,.fg-bs-grid{grid-template-columns:repeat(4,minmax(0,1fr)) !important}@media screen and (max-width:989px){.fg-cat-grid,.fg-na-grid,.fg-bs-grid{grid-template-columns:repeat(2,minmax(0,1fr)) !important}.fg-na-grid,.fg-bs-grid{gap:24px 14px !important}.fg-na-card,.fg-bs-card,.fg-cat-tile{min-width:0}.fg-na-title,.fg-bs-title{font-size:14px !important;line-height:1.35 !important;letter-spacing:0 !important;-webkit-hyphens:auto;hyphens:auto;overflow-wrap:break-word;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.fg-cat-grid{grid-auto-rows:1fr;gap:12px !important}.fg-cat-tile{padding:18px 16px !important;gap:10px !important}.fg-cat-title{font-size:15px !important;line-height:1.25 !important;letter-spacing:0 !important;-webkit-hyphens:auto;hyphens:auto;overflow-wrap:break-word}.fg-cat-sub{font-size:12.5px !important;line-height:1.35 !important;letter-spacing:0 !important}.fg-cat-tile:last-child:nth-child(odd){grid-column:1/-1}}.product-card-wrapper .card,.product-card-wrapper .card__inner{--ratio-percent:100% !important}.product-card-wrapper .card__media .media img{object-fit:contain !important}.fzf .fzf__result-card-img:not([src]){background:#f1f1f1 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b0b0b0' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='4' width='18' height='16' rx='2'/%3E%3Ccircle cx='9' cy='10' r='1.8'/%3E%3Cpath d='M21 16l-5-5-9 9'/%3E%3C/svg%3E\") center/45% no-repeat !important}@media screen and (max-width:749px){.fzf .fzf__result-card{display:grid !important;grid-template-columns:72px minmax(0,1fr) !important;grid-template-areas:\"img info\" \"cta cta\" !important;align-items:center !important;gap:12px 14px !important;padding:14px !important;background:#fff !important}.fzf .fzf__result-card-img{grid-area:img !important;width:72px !important;height:72px !important;flex:none !important}.fzf .fzf__result-card-info{grid-area:info !important}.fzf .fzf__result-card-title{font-size:15px !important;line-height:1.35 !important;letter-spacing:0 !important;margin:0 0 6px !important;overflow-wrap:break-word !important}.fzf .fzf__result-card-price{font-size:17px !important;line-height:1.2 !important;letter-spacing:0 !important;margin:0 !important;opacity:1 !important;white-space:nowrap !important}.fzf .fzf__result-cta{grid-area:cta !important;display:block !important;width:100% !important;text-align:center !important;padding:12px 16px !important;font-size:15px !important;box-sizing:border-box !important}}";
  (document.head || document.documentElement).appendChild(st);
})();

/* ---- Weitere Marken (Wieres-Produktfinder): eine Sammeldatei, Adresse endet auf #fzfb=<marke> ---- */
(function () {
  if (window.__fgFzfBundle || !window.fetch) return;
  window.__fgFzfBundle = true;
  var nativeFetch = window.fetch, cache = {};
  window.fetch = function (input, init) {
    var s = typeof input === 'string' ? input : '';
    var i = s.indexOf('#fzfb=');
    if (i === -1) return nativeFetch.apply(this, arguments);
    var base = s.slice(0, i), slug = decodeURIComponent(s.slice(i + 6));
    if (!cache[base]) {
      cache[base] = nativeFetch.call(window, base).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
      cache[base].catch(function () { delete cache[base]; });
    }
    return cache[base].then(function (all) {
      var b = all && all.brands && all.brands[slug];
      if (!b) return new Response('', { status: 404 });
      return new Response(JSON.stringify({ vehicles: b.vehicles, products: all.products }), { status: 200, headers: { 'Content-Type': 'application/json' } });
    });
  };
})();
